import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";

const HERO_IMAGE = "https://images.unsplash.com/photo-1762811054950-b74e0a055c80?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBiYWNreWFyZCUyMHBvb2wlMjBuaWdodCUyMGNpbmVtYXRpYyUyMGxpZ2h0aW5nfGVufDB8fHx8MTc3MzYyOTQ5MHww&ixlib=rb-4.1.0&q=85";

export const HeroSection = () => {
  const scrollToServices = () => {
    document.getElementById("positioning")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section data-testid="hero-section" className="relative h-screen overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={HERO_IMAGE}
          alt="Aménagement paysager de luxe"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-[#0A0A0A]" />
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col justify-end pb-24 md:pb-32 px-6 md:px-12 max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.3, ease: "easeOut" }}
        >
          <p className="font-sans text-xs uppercase tracking-[0.3em] text-[#E8891C] mb-6" data-testid="hero-label">
            Montcalm, Québec
          </p>
          <h1
            className="font-serif text-4xl sm:text-5xl lg:text-6xl xl:text-7xl text-[#F5F5F0] leading-[1.1] tracking-tight max-w-4xl mb-6"
            data-testid="hero-title"
          >
            L'excellence extérieure,<br />
            <span className="italic">pensée dans les moindres détails.</span>
          </h1>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.7, ease: "easeOut" }}
        >
          <p className="font-sans text-base md:text-lg text-[#A1A1AA] max-w-xl mb-10 leading-relaxed" data-testid="hero-subtitle">
            Des réalisations sur mesure qui valorisent durablement votre propriété.
          </p>
          <button
            data-testid="hero-cta-button"
            onClick={() => document.getElementById("portfolio")?.scrollIntoView({ behavior: "smooth" })}
            className="group inline-flex items-center gap-3 bg-[#E8891C] text-[#0A0A0A] px-8 py-4 font-sans text-xs font-semibold uppercase tracking-[0.2em] hover:bg-[#F5A642] transition-colors duration-500"
          >
            Découvrir nos réalisations
            <span className="inline-block transition-transform duration-300 group-hover:translate-x-1">&rarr;</span>
          </button>
        </motion.div>

        {/* Scroll indicator */}
        <motion.div
          className="absolute bottom-8 left-1/2 -translate-x-1/2"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.5, duration: 0.5 }}
        >
          <button onClick={scrollToServices} className="flex flex-col items-center gap-2 text-[#A1A1AA]/50 hover:text-[#E8891C] transition-colors duration-300" data-testid="scroll-indicator">
            <span className="font-sans text-[10px] uppercase tracking-[0.3em]">Défiler</span>
            <ChevronDown size={16} className="animate-bounce" />
          </button>
        </motion.div>
      </div>
    </section>
  );
};
